<template>
  <section>
    <!-- Section Business Hero -->
    <section class="section-business">
      <div class="row">
        <div class="col-md-8 col-8 business-content">
          <div class="hero-title">{{ $t('message.business.title') }}</div>
          <div class="hero-sub-title">{{ $t('message.business.sub_title') }}</div>
        </div>
      </div>
    </section>

    <section class="section-padding section-business-ais">
      <div class="row">
        <div class="col-md-8 offset-sm-2">
          <div class="mb-5"><img src="/static/img/ais-logo-white.svg" width="240" alt=""></div>
          <div>
            สิทธิพิเศษเฉพาะลูกค้า AIS ภาคธุรกิจเท่านั้น<br>
            รับส่วนลด 10%
          </div>
          <div class="mt-3 -white">
            เพียงกด *545*800*14# แล้วโทรออก
          </div>
          <div class="mt-3 description">
            จากนั้น นำรหัสส่วนลดไปกรอกที่แบบฟอร์มลงทะเบียนด้านล่าง<br>
            <!-- หรือติดต่อ LineID: <a href="https://line.me/R/ti/p/%40hnk7011n">@beneat</a> -->
            หรือติดต่อ LineID: <a href="https://line.me/R/ti/p/@BeNeat">@BeNeat</a>
          </div>
          <div class="mt-4 ais-conditions">
            <div>เงื่อนไขการรับสิทธิ์</div>
            <ol>
              <li>สิทธิพิเศษนี้ สำหรับลูกค้า AIS ที่เป็นสมาชิก BIZ UP เท่านั้น</li>
              <li>หลังจากที่เป็นสมาชิก BIZ UP แล้วสามารถเริ่มรับสิทธิพิเศษได้ในวันถัดไป</li>
              <li>รับสิทธิ์ได้ 1 ครั้งตลอดระยะเวลาโครงการ</li>
              <li>จำนวนจำกัด 20 สิทธิ์/เดือน</li>
              <li>เฉพาะพื้นที่กรุงเทพ และ ปริมณฑล</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <!-- Form -->
    <section class="section-padding-gray">
      <h2 class="text-center">ลงทะเบียนเพื่อรับส่วนลดจาก AIS</h2>
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <div class="card">
            <div class="card-body">
              <div class="row mb-5">
                <div class="col-12 text-center">
                  <img src="/static/img/ais-logo.svg" width="140" alt="">
                </div>
              </div>
              <div class="form">
                <div class="form-group">
                  <label for="name">{{ $t('message.business.contact_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="name"
                         ref="name"
                         v-model="contactData.name"
                         required>
                </div>
                <div class="form-group">
                  <label for="company_name">{{ $t('message.business.contact_company_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="company_name"
                         ref="company_name"
                         v-model="contactData.company_name"
                         required>
                </div>
                <div class="form-group">
                  <label for="email">{{ $t('message.business.contact_email') }}*</label>
                  <input type="email"
                         class="form-control input-jumbo"
                         id="email"
                         ref="email"
                         v-model="contactData.email"
                         required>
                </div>
                <div class="form-group">
                  <label for="tel">{{ $t('message.business.contact_tel') }}*</label>
                  <input type="tel"
                         class="form-control input-jumbo"
                         id="tel"
                         ref="tel"
                         v-model="contactData.tel"
                         required>
                </div>
                <div class="form-group">
                  <label for="promo_code">{{ $t('message.business.promo_code') }} (กด *545*800*14# แล้วโทรออก)</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="promo_code"
                         ref="promo_code"
                         v-model="contactData.promo_code"
                         required>
                </div>
              </div>
              <button class="button button-large button-block -cyan"
                      @click="sendEmail"> {{ $t(isSending) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section Why Choose Us ? -->
    <section class="section-padding section-solution">
      <h2 class="text-center">{{ $t('message.business.customer_title') }}</h2>
      <div class="row">
        <div class="col-12 col-md-8 offset-sm-2 solution-description">
          <p>{{ $t('message.business.customer_sub_title') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-image">
              <img src="/static/img/startup-office.jpg" alt="">
            </div>
            <div class="card-body">
              <div class="text-center" style="padding-top: 0.5rem">
                <h3 class="price-city">{{ $t('message.business.customer01') }}</h3>
              </div><!-- price -->
            </div>
          </div>
        </div>
        <!-- /.col-md-4 -->

        <div class="col-md-4">
          <div class="card">
            <div class="card-image">
              <img src="/static/img/small-office.jpeg" alt="">
            </div>
            <div class="card-body">
              <div class="text-center" style="padding-top: 0.5rem">
                <h3 class="price-city">{{ $t('message.business.customer02') }}</h3>
              </div><!-- price -->
            </div>
          </div>
        </div>
        <!-- /.col-md-4 -->

        <div class="col-md-4">
          <div class="card">
            <div class="card-image">
              <img src="/static/img/home-office.jpeg" alt="">
            </div>
            <div class="card-body">
              <div class="text-center" style="padding-top: 0.5rem">
                <h3 class="price-city">{{ $t('message.business.customer03') }}</h3>
              </div><!-- price -->
            </div>
          </div>
        </div>
        <!-- /.col-md-4 -->
      </div>
    </section>

    <!-- Section Why Choose Us ? -->
    <section class="section-solution section-padding-gray">
      <h2 class="text-center">{{ $t('message.business.benefits_title') }}</h2>
      <p>&nbsp;</p>
      <div class="row">
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/no-contract.svg" width="60">
          <h3>{{ $t('message.business.benefits01_title') }}</h3>
          <p>{{ $t('message.business.benefits01_description') }}</p>
        </div>
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/adjust.svg" width="60">
          <h3>{{ $t('message.business.benefits02_title') }}</h3>
          <p>{{ $t('message.business.benefits02_description') }}</p>
        </div>
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/receipt.svg" width="60">
          <h3>{{ $t('message.business.benefits03_title') }}</h3>
          <p>{{ $t('message.business.benefits03_description') }}</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/protect.svg" width="60">
          <h3>{{ $t('message.business.benefits04_title') }}</h3>
          <p>{{ $t('message.business.benefits04_description') }}</p>
        </div>
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/cleaning-equipment.svg" width="60">
          <h3>{{ $t('message.business.benefits05_title') }}</h3>
          <p>{{ $t('message.business.benefits05_description') }}</p>
        </div>
        <div class="col-sm-4 col-md-4 text-center">
          <img src="/static/img/saving.svg" width="60">
          <h3>{{ $t('message.business.benefits06_title') }}</h3>
          <p>{{ $t('message.business.benefits06_description') }}</p>
        </div>
      </div>
    </section>

    <!-- Section Media -->
    <section-partner />

    <!-- Section Contact Us -->
    <section class="section-padding-gray">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2>ติดต่อเรา</h2>
          <div class="business-contact">
            <div class="mb-3">
              <i class="fas fa-phone-square text-primary"></i>
              <a href="tel:021131138">02-113-1138</a>
            </div>
            <div class="mb-3">
              <i class="fas fa-envelope text-primary"></i>
              <a href="mailto:info@beneat.co">info@beneat.co</a>
            </div>
            <div class="mt-3">
              <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="my-4 text-center">
        {{ $t('message.hero.or') }}
      </div> -->

    </section>

  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SectionPartner from '../SectionPartner.vue'
  export default {
    components: {
      SectionPartner
    },
    data () {
      return {
        contactData: {
          name: '',
          company_name: '',
          email: '',
          tel: '',
          promo_code: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        isSendingEmail: 'business/getIsSendingEmail',
        isSending: 'business/isSending'
      })
    },
    watch: {
      isSendingEmail () {
        if (!this.isSendingEmail) {
          this.contactData = {
            name: '',
            company_name: '',
            email: '',
            tel: ''
          }
          this.$swal({
            type: 'success',
            title: this.$i18n.t('message.business.thank_you'),
            text: this.$i18n.t('message.business.contact_you_soon')
          })
        }
      }
    },
    methods: {
      validation () {
        let result = true
        const emailFormat = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        if (this.contactData.name === '') {
          this.$refs.name.focus()
          result = false
        } else if (this.contactData.company_name === '') {
          this.$refs.company_name.focus()
          result = false
        } else if (this.contactData.email === '') {
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.email && !emailFormat.test(this.contactData.email)) {
          this.contactData.email = ''
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.tel === '') {
          this.$refs.tel.focus()
          result = false
        } else if (this.contactData.promo_code === '') {
          this.$refs.promo_code.focus()
          result = false
        } else {
          result = true
        }
        return result
      },
      sendEmail () {
        if (this.validation()) {
          this.$store.dispatch('business/SEND_EMAIL', this.contactData)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.ais-conditions {
  font-size: 1rem;
  li {
    margin-left: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/information/BusinessAis.vue